import React from "react";

import { DropDownButton } from "./DropDownButton";
import { withRouter } from "../utilities/withRouter";
import { connect } from "react-redux";
import { iconMap } from "../utilities/utilities";
import { bulkUploadMultipleFiles } from "../actions/newDocumentUpload";
import { createNewDocumentFromTemplate } from "../actions/newDocumentActions";
import {
	createNewDocumentSubmitHandler,
	createNewDocumentValidationHandler,
} from "./mandatoryProfiling/dialog/NewDocumentWithProfilingDialog";

import {
	openGlobalDialog,
	closeGlobalDialog,
} from "../actions/globalEditDialogActions";
import "./DropDownButton.css";
import {
	createNewMatterFromClioMatter,
	openPullMatterFromClioDialog,
} from "../actions/clioIntegrationActions";
import { showNewFolderDialog } from "../actions/folderActions";

import API from "../utilities/LocalApiProxy";

import {
	IconBriefcase,
	IconFileUpload,
	IconFolderFilled,
	IconUsersGroup,
} from "@tabler/icons-react";
import { getCurrentFolderDisabledState } from "../utilities/lifecycleStatus";

const DropdownWithRouter = withRouter(DropDownButton);

const documentTypes = {
	docx: { fullLabel: "Word Document", placeHolder: "Document" },
	xlsx: { fullLabel: "Excel Spreadsheet", placeHolder: "Spreadsheet" },
	pptx: { fullLabel: "PowerPoint Presentation", placeHolder: "Presentation" },
	txt: { fullLabel: "Text File", placeHolder: "Text File" },
};

class NewItemDropdown extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.openNewDocumentDialog = this.openNewDocumentDialog.bind(this);

		this.getDisabledStateAndText = this.getDisabledStateAndText.bind(this);
	}

	openNewDocumentDialog(extension) {
		const { directoryID } = this.props;

		// Show loading dialog
		this.props.openGlobalDialog({
			label: "Loading...",
			hideTextfield: true,
			hideCancelButton: true,
			readOnly: true,
			mainText: "Checking document requirements...",
		});

		// Check mandatory profiling requirements
		API.post("/document/checkMandatoryProfilingForNewDocument", {
			body: {
				directoryID,
				extension,
			},
		})
			.then((res) => {
				// Close loading dialog
				this.props.closeGlobalDialog();

				const {
					stronglySuggestProfiling,
					requiredFields,
					availableOptions,
				} = res.mysql;

				// Always use the same dialog, pass promptForProfiling to control rendering
				this.props.openGlobalDialog(
					{
						type: "NewDocumentWithMandatoryProfiling",
						label: `Create New ${documentTypes[extension].fullLabel}`,
						placeHolder: `New ${documentTypes[extension].placeHolder}`,
						value: "",
						submitButtonLabel: "Create and Open Document",
						newDocumentProfilingConfig: {
							stronglySuggestProfiling,
							requiredFields,
							availableOptions,
							extension,
						},
					},
					createNewDocumentSubmitHandler({
						extension,
						createNewDocumentFromTemplate:
							this.props.createNewDocumentFromTemplate,
						directoryID: this.props.directoryID,
						cognitoSub: this.props.cognitoSub,
					}),
					createNewDocumentValidationHandler({
						extension,
						directoryID,
						documentList: this.props.documentList,
						requiredFields: requiredFields,
					})
				);
			})
			.catch((err) => {
				this.props.closeGlobalDialog();
				console.error("Error checking mandatory profiling:", err);
			});
	}

	getDisabledStateAndText(itemType) {
		const onCreatablePage = this.props.creatableContext;
		const currentRoot = this.props.currentRoot;

		if (
			!onCreatablePage ||
			(currentRoot.indexOf("docs/") !== 0 &&
				currentRoot.indexOf("public/") !== 0 &&
				currentRoot.indexOf("private/") !== 0)
		) {
			return {
				disabled: true,
				disabledHoverText:
					itemType === "Upload"
						? "Documents can only be uploaded to the Documents tab of a matter"
						: `${itemType} can only be created within the Documents tab of a matter`,
			};
		}
		if (this.props.matterOrFolderLifecycleStatusObject.disabled) {
			return {
				disabled: true,
				disabledHoverText:
					this.props.matterOrFolderLifecycleStatusObject.disabledText,
			};
		}
		return {
			disabled: false,
			disabledHoverText: "",
		};
	}

	getMenuItems() {
		const documentsDisabledState =
			this.getDisabledStateAndText("Documents");
		const folderDisabledState = this.getDisabledStateAndText("Folders");
		const uploadDisabledState = this.getDisabledStateAndText("Upload");

		const newDocMenuItem = (extension) => {
			let { iconComponent } = iconMap({
				original: {
					filename: "." + extension,
					type: "File",
				},
				color: documentsDisabledState.disabled ? "#aaaaaa" : undefined,
			});
			return {
				text: documentTypes[extension].fullLabel,
				onSelect: () => this.openNewDocumentDialog(extension),
				disabled: documentsDisabledState.disabled,
				iconComponent,
				disabledHoverText: documentsDisabledState.disabledHoverText,
			};
		};

		const disableMatter = !this.props.canCreateMatter;
		const disableClient = !this.props.canCreateClient;

		var menuItems = [
			{
				text: "Matter",
				href: "/matters/new",
				iconComponent: (
					<IconBriefcase
						size={16}
						style={{ verticalAlign: "middle", marginRight: "8px" }}
						color={
							disableMatter ? "#aaaaaa" : "var(--lxw-main-500)"
						}
					/>
				),
				disabled: disableMatter,
				disabledHoverText:
					"You do not have permissions to create new matters",
			},
		];

		if (
			this.props.clioIntegrationSettingStatus !== undefined &&
			this.props.clioIntegrationSettingStatus
		) {
			menuItems.push({
				text: "Matter (From Clio)",
				onSelect: () => this.props.openPullMatterFromClioDialog(),
				iconComponent: (
					<IconBriefcase
						size={16}
						style={{ verticalAlign: "middle", marginRight: "8px" }}
						color={
							disableMatter ? "#aaaaaa" : "var(--lxw-main-500)"
						}
					/>
				),
				disabled: disableMatter,
				disabledHoverText:
					"You do not have permissions to create new matters",
			});
		}

		menuItems = menuItems.concat([
			{
				text: "Client",
				href: "/clients/new",
				iconComponent: (
					<IconUsersGroup
						size={16}
						style={{ verticalAlign: "middle", marginRight: "8px" }}
						color={
							disableClient ? "#aaaaaa" : "var(--lxw-main-500)"
						}
					/>
				),
				disabled: disableClient,
				disabledHoverText:
					"You do not have permissions to create new clients",
			},
			newDocMenuItem("docx"),
			newDocMenuItem("xlsx"),
			newDocMenuItem("pptx"),
			newDocMenuItem("txt"),
			{
				text: "Folder",
				onSelect: () =>
					this.props.showNewFolderDialog({
						matterID: this.props.matterID,
						apiBasepath: this.props.currentLxwFolderBasepath,
						currentLocationFilesAndFolders: this.props.documentList,
					}),
				disabled: folderDisabledState.disabled,
				iconComponent: (
					<IconFolderFilled
						size={16}
						color={
							folderDisabledState.disabled
								? "#aaaaaa"
								: "var(--lw-folder-icon-yellow)"
						}
						style={{ verticalAlign: "middle", marginRight: "8px" }}
					/>
				),
				disabledHoverText: folderDisabledState.disabledHoverText,
			},
			{
				text: "Upload a Document",
				type: "multi-file-upload",
				onSelect: () => console.log("UPLOAD"),
				disabledHoverText: uploadDisabledState.disabledHoverText,
				disabled: uploadDisabledState.disabled,
				iconComponent: (
					<IconFileUpload
						size={16}
						style={{ verticalAlign: "middle", marginRight: "8px" }}
						color={
							uploadDisabledState.disabled
								? "#aaaaaa"
								: "var(--lxw-main-500)"
						}
					/>
				),
				iconColor: uploadDisabledState.disabled ? "#aaaaaa" : "black",
				fileListChangeHandler: (files) => {
					let myMatterID = this.props.matterID;
					if (this.props.matterID !== 0) {
						// need to send matterID as string if it is not 0
						myMatterID = `${this.props.matterID}`;
					}
					this.props.bulkUploadMultipleFiles({
						matterID: myMatterID,
						basepath: this.props.currentLxwFolderBasepath,
						directoryID: this.props.directoryID,
						files,
						autoRename: false, //autoRename parameter.  False on first call
						callback: () => console.log("callback"),
					});
				},
			},
		]);
		return menuItems;
	}
	render() {
		return (
			<DropdownWithRouter
				title="New"
				noIcon
				menuItems={this.getMenuItems()}
			/>
		);
	}
}

const mapStateToProps = (state) => {
	const matterID =
		state.document.currentRoot.indexOf("public/") === 0 ||
		state.document.currentRoot.indexOf("private/") === 0
			? 0
			: state.matter.matterDetails.id;

	const matterOrFolderLifecycleStatusObject = getCurrentFolderDisabledState(
		state.document
	);
	return {
		documentList: state.document.documentList,
		currentLxwFolderBasepath: state.document.originalPrefix, //eg: docs/FolderA/FolderB/  or public/folder1/ (for firm docs)`
		directoryID: state.document.directoryID,
		currentRoot: state.document.currentRoot,
		creatableContext: state.currentPage.creatableContext,
		matterID,
		dropDownListData: state.clioIntegration.clioMatterListData,
		clioIntegrationSettingStatus: state.tenant.clioIntegrationSettingStatus,
		canCreateClient: state.user.userRights.CREATE_CLIENT_ALLOWED,
		canCreateMatter: state.user.userRights.CREATE_MATTER_ALLOWED,
		cognitoSub: state.user.cognitoUser.attributes.sub,
		matterOrFolderLifecycleStatusObject,
	};
};
export default connect(mapStateToProps, {
	openGlobalDialog,
	closeGlobalDialog,
	createNewDocumentFromTemplate,
	bulkUploadMultipleFiles,
	createNewMatterFromClioMatter,
	openPullMatterFromClioDialog,
	showNewFolderDialog,
})(NewItemDropdown);
